import React from "react";

import { Link, useNavigate } from "react-router-dom";
/// Image
import { Dropdown } from "react-bootstrap";
import Logout from "../../pages/Authintication/Logout";
import { useDispatch, useSelector } from "react-redux";
import { setLang } from "../../../store/actions/AuthActions";
import { Translate } from "../../Enums/Tranlate";
import usa from "../../../images/usa.svg";
import kwait from "../../../images/kwait.svg";

const Header = ({ onNote }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const lang = useSelector((state) => state.auth.lang);
	const admin = useSelector((state) => state.auth.auth.admin);
	var path = window.location.pathname.split("/");
	var name = path[path.length - 1].split("-");
	var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;
	var finalName = filterName;

	return (
		<div className="header">
			<div className="header-content">
				<nav className="navbar navbar-expand">
					<div className="collapse navbar-collapse justify-content-between">
						<div className="header-left">
							<div
								className="dashboard_bar d-flex"
								style={{ textTransform: "capitalize", alignItems: "center" }}>
								{!finalName?.join("_")
									? Translate[lang].dashboard
									: Translate[lang][finalName.join("_")]}
							</div>
						</div>
						<ul className="navbar-nav header-right p-0">
							<Dropdown
								as="li"
								className="nav-item dropdown notification_dropdown ">
								<Dropdown.Toggle
									variant=""
									className="nav-link ai-icon"
									href="#"
									role="button"
									style={{
										background: "#F3F6F9",
									}}
									data-toggle="dropdown">
									<img
										src={lang === "en" ? usa : kwait}
										width={21}
										alt="language"
									/>{" "}
									<i
										className="la la-angle-down"
										style={{ fontSize: "12px" }}></i>
								</Dropdown.Toggle>

								<Dropdown.Menu align="right" className="mt-2 custom-dropdown">
									<ul className="timeline text-center">
										<li
											className="py-2"
											style={{
												backgroundColor:
													lang === "en" ? "var(--bg-color)" : "#fff",
												color: lang === "en" ? "#fff" : "var(--bg-color)",
												cursor: "pointer",
											}}
											onClick={() => dispatch(setLang("en"))}>
											English
										</li>
										<li
											className="py-2"
											style={{
												backgroundColor:
													lang === "ar" ? "var(--bg-color)" : "#fff",
												color: lang === "ar" ? "#fff" : "var(--bg-color)",
												cursor: "pointer",
											}}
											onClick={() => dispatch(setLang("ar"))}>
											اللغه العربيه
										</li>
									</ul>
								</Dropdown.Menu>
							</Dropdown>

							<Dropdown as="li" className="nav-item dropdown header-profile">
								<Dropdown.Toggle
									variant=""
									as="a"
									className="nav-link i-false"
									style={{
										background: "var(--primary)",
										color: "#fff",
										padding: "5px 13px",
										borderRadius: ".5rem",
										textTransform: "capitalize",
										cursor: "pointer",
									}}>
									{/* <i className="la la-user" style={{fontSize: '32px', color: 'var(--primary)'}}></i> */}
									<span>
										{!admin?.f_name ? (
											<svg
												width="20"
												height="20"
												xmlns="http://www.w3.org/2000/svg"
												viewBox="0 0 32 32">
												<path
													fill="#fff"
													d="M26.67 27.43h1.52V32h-1.52Zm-1.53-1.52h1.53v1.52h-1.53Zm-1.52 1.52h1.52v1.52h-1.52Zm0-3.05h1.52v1.53h-1.52Zm-1.53 4.57h1.53v1.53h-1.53Zm-1.52-6.09h3.05v1.52h-3.05Zm1.52-12.19h1.53v4.57h-1.53Zm-1.52 19.81h1.52V32h-1.52Zm0-15.24h1.52v1.52h-1.52Zm-1.52-6.1h3.04v1.53h-3.04Zm0 15.24h1.52v1.53h-1.52Zm-1.53-3.05h3.05v1.53h-3.05Zm1.53-4.57h1.52v1.53h-1.52Zm-1.53 9.15h1.53v1.52h-1.53Zm0-7.62h1.53v1.52h-1.53Zm0-7.62h1.53v1.52h-1.53ZM16 27.43h1.52v1.52H16Zm0-7.62h1.52v1.52H16Zm0-7.62h1.52v1.52H16Zm-1.52 9.14H16v1.53h-1.52Zm0-7.62H16v1.53h-1.52Zm-1.53 9.15h1.53v1.52h-1.53Zm0-7.62h1.53v1.52h-1.53Zm-1.52 1.52h1.52v1.53h-1.52Zm0-4.57h1.52v3.05h-1.52Zm-1.53 6.1h1.53v1.52H9.9ZM9.9 0v1.52H8.38v3.05H9.9V6.1h1.53v1.52h1.52v1.52h1.53V7.62H16V6.1h1.52V4.57h1.53V1.52h-1.53V0h-3.04v1.52h-1.53V0zM6.86 10.67h4.57v1.52H6.86Zm1.52 6.09H6.86v6.1h1.52v-1.53H9.9v-1.52H8.38zm-3.05 6.1h1.53v1.52H5.33Zm0-10.67h1.53v4.57H5.33ZM3.81 24.38h1.52V32H3.81Z"
												/>
											</svg>
										) : (
											admin?.f_name?.charAt(0)
										)}
									</span>
								</Dropdown.Toggle>

								<Dropdown.Menu align="right" className="mt-2 custom-dropdown">
									<Link to="/profile" className="dropdown-item ai-icon">
										<svg
											id="icon-user1"
											xmlns="http://www.w3.org/2000/svg"
											className="text-primary"
											width={18}
											height={18}
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											strokeWidth={2}
											strokeLinecap="round"
											strokeLinejoin="round">
											<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
											<circle cx={12} cy={7} r={4} />
										</svg>
										<span className={lang === "en" ? "ml-2" : "mr-2"}>
											{Translate[lang]?.profile}{" "}
										</span>
									</Link>
									<Logout />
								</Dropdown.Menu>
							</Dropdown>
						</ul>
					</div>
				</nav>
			</div>
		</div>
	);
};

export default Header;
